var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "sc-bdvvtL sc-iCfMLu gBfQOf sc-cCcXHH dywJep",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.868 2a2.91 2.91 0 0 1-.665 2.084 2.447 2.447 0 0 1-1.932.913 2.768 2.768 0 0 1 .682-2.006A2.96 2.96 0 0 1 11.868 2Zm1.35 5.493a2.955 2.955 0 0 0-.384 1.42 2.855 2.855 0 0 0 1.742 2.627 6.543 6.543 0 0 1-.906 1.846c-.534.799-1.094 1.579-1.982 1.593-.423.01-.708-.111-1.005-.238-.31-.132-.633-.27-1.139-.27-.536 0-.874.142-1.2.28-.28.118-.553.232-.937.248-.846.031-1.493-.852-2.046-1.644-1.106-1.615-1.967-4.553-.813-6.552a3.173 3.173 0 0 1 2.67-1.629c.48-.01.941.176 1.345.338.309.124.584.234.81.234.198 0 .466-.106.778-.23.492-.195 1.094-.434 1.707-.37a3.025 3.025 0 0 1 2.383 1.289 2.955 2.955 0 0 0-1.022 1.058Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c504f5a85f90ff5af59decd7b9062426.svg";
export { ForwardRef as ReactComponent };